import jsCookie from 'js-cookie'
import queryString from 'query-string'
import fetch from '@/plugins/fetch'
import loading from '@/components/common/loading'
import { Toast } from 'kf-component-vue'
import config from '@/plugins/config'
import clipboard from 'clipboard'
import utils from './utils'
import { newTrackClick, newTrackView } from '@/utils/newTrack'

export default function install(Vue) {
  Vue.prototype.$$cookie = jsCookie
  Vue.prototype.$$hostname = utils.hostname
  Vue.prototype.$$host = utils.host
  Vue.prototype.$$getDevice = utils.getDevice
  Vue.prototype.$$title = utils.title
  Vue.prototype.$$login = utils.login
  Vue.prototype.$$ensureLogin = utils.ensureLogin
  Vue.prototype.$$ensureLoginWithPhone = utils.ensureLoginWithPhone
  Vue.prototype.$$queryString = queryString
  Vue.prototype.$$toast = Toast
  Vue.prototype.$$fetch = fetch
  const Loading = Vue.extend(loading)
  const ele = new Loading({
    el: document.createElement('div')
  })
  window.__Loading = ele
  document.body.appendChild(ele.$el)
  Vue.prototype.$$loading = (flg = true) => {
    const className = ele.$el.className
    ele.show = flg
    return !ele.show
  }
  Vue.prototype.$$dateFormat = utils.dateFormat
  Vue.prototype.$$cent2yuan = utils.cent2yuan
  Vue.prototype.$$isIdCard = utils.isIdCard
  Vue.prototype.$$kefu = (appPageSource, h5PageSource, param) => {
    const device = utils.getDevice()
    const isMobile = device === 'ios' && device === 'android'
    const version = parseFloat(jsCookie.get('version'), 10)
    const versionControl =
      (device === 'ios' && version >= 5.0) ||
      (device === 'android' && version >= 50)
    const param_new = {
      ...param,
      cmd: versionControl ? 'imktalk' : 'kwservice',
      pageSource: isMobile ? appPageSource : h5PageSource
    }
    const query = queryString.stringify(param_new)
    location.href = `${utils.hostname('im')}/r.html?${query}`
  }
  Vue.prototype.$$share = utils.share
  Vue.prototype.$$viewImage = utils.viewImage
  Vue.prototype.$$viewImageInCenter = utils.viewImageInCenter
  Vue.prototype.$$avatar = utils.avatar
  Vue.prototype.$$workerAvatar = utils.workerAvatar
  Vue.prototype.$$tracker = utils.tracker
  Vue.prototype.$$newTrackClick = newTrackClick
  Vue.prototype.$$newTrackView = newTrackView
  Vue.prototype.$$config = config
  Vue.prototype.$$error = (e, vm) => {
    Vue.config.errorHandler.call(null, e, vm)
  }
  Vue.prototype.$$isHZWApp = utils.isHzwApp
  Vue.prototype.$$isRkhy = utils.isRkhy
  Vue.prototype.$$isMp = utils.isMp
  Vue.prototype.$$isCZJApp = utils.isCzjApp
  Vue.prototype.$$isMiniProgramAsync = utils.isMiniProgramAsync
  Vue.prototype.$$allowRefreshOrShare = utils.allowRefreshOrShare
  Vue.prototype.$$clipboard = clipboard
}
